/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LookupReleaseQuery
 */
export interface LookupReleaseQuery {
    /**
     * Release id at source (e.g. discogs)
     * @type {string}
     * @memberof LookupReleaseQuery
     */
    sourceId: string;
    /**
     * Source system
     * @type {string}
     * @memberof LookupReleaseQuery
     */
    source: LookupReleaseQuerySourceEnum;
}


/**
 * @export
 */
export const LookupReleaseQuerySourceEnum = {
    Discogs: 'discogs',
    Mb: 'MB',
    Spotify: 'spotify',
    Deezer: 'deezer',
    Ppl: 'ppl'
} as const;
export type LookupReleaseQuerySourceEnum = typeof LookupReleaseQuerySourceEnum[keyof typeof LookupReleaseQuerySourceEnum];


/**
 * Check if a given object implements the LookupReleaseQuery interface.
 */
export function instanceOfLookupReleaseQuery(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sourceId" in value;
    isInstance = isInstance && "source" in value;

    return isInstance;
}

export function LookupReleaseQueryFromJSON(json: any): LookupReleaseQuery {
    return LookupReleaseQueryFromJSONTyped(json, false);
}

export function LookupReleaseQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupReleaseQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sourceId': json['source_id'],
        'source': json['source'],
    };
}

export function LookupReleaseQueryToJSON(value?: LookupReleaseQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source_id': value.sourceId,
        'source': value.source,
    };
}

